<template>
    <KtvCard
        :title="$t('ktvThen.ktvPhoneTypes.title')"
        :description="$t('ktvThen.ktvPhoneTypes.description')"
        icon="check-circle"
        :is-complete="isCompleteAndValid"
        :show-error="showError"
    >
        <template #content>
            <DsMultiselect
                v-model="internalPhoneTypes"
                bind-value-only
                class="ktv-phone-type-selector"
                data-qa="ktv-phone-type-selector"
                multiple
                :options="options"
                :placeholder="$t('ktvThen.ktvPhoneTypes.selectText')"
                :readonly="readOnly"
                searchable
                :force-invalid="showError"
                @input="handleInput"
            >
                <template #help>
                    <span v-if="showError && internalPhoneTypes.length === 0">
                        {{ $t('ktvThen.ktvPhoneTypes.errorText') }}
                    </span>
                </template>
            </DsMultiselect>

            <div class="ktv-phone-type-help">
                <DsLink
                    as="button"
                    :trailing-icon="isPhoneTypesExplanationOpen ? 'chevron-up' : 'chevron-down'"
                    data-qa="ktv-broadcast-phone-type-link"
                    @click="isPhoneTypesExplanationOpen = !isPhoneTypesExplanationOpen"
                >
                    {{ $t('ktvThen.ktvPhoneTypes.help') }}
                </DsLink>

                <div v-if="isPhoneTypesExplanationOpen" class="ktv-phone-type-explanation">
                    <div data-qa="ktv-then-phone-type-explanation">
                        {{ $t('ktvThen.ktvPhoneTypes.explanation') }}
                    </div>
                </div>
            </div>
        </template>
    </KtvCard>
</template>

<script>
import KtvCard from './KtvCard.vue';

export default {
    components: { KtvCard },

    props: {
        showError: {
            type: Boolean,
            default: false,
        },
        phoneTypes: {
            type: Array,
            default: () => [],
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            internalPhoneTypes: this.phoneTypes,
            options: [
                { value: 'Mobile', label: this.$t('ktvThen.ktvPhoneTypes.types.mobile') },
                { value: 'Work', label: this.$t('ktvThen.ktvPhoneTypes.types.work') },
                { value: 'Home', label: this.$t('ktvThen.ktvPhoneTypes.types.home') },
                { value: 'Other', label: this.$t('ktvThen.ktvPhoneTypes.types.other') },
            ],
            isPhoneTypesExplanationOpen: false,
        };
    },

    computed: {
        isCompleteAndValid() {
            return !!this.internalPhoneTypes.length && !this.showError;
        },
    },

    watch: {
        phoneTypes: {
            handler(value) {
                this.internalPhoneTypes = value;
            },
            immediate: true,
            deep: true,
        },
    },

    methods: {
        handleInput(value) {
            this.internalPhoneTypes = value;
            this.$emit('input', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.ktv-phone-type-explanation {
    padding-top: $spacing-100;
    color: $color-ink-800;
    font-family: $font-family;
    font-size: $font-size-sm;
    font-weight: $font-weight-regular;
    line-height: $line-height-md;
}
</style>
